<template>
    <div>
        <div class = "loadingContainer" v-if="isLoading">
            <v-progress-circular
              indeterminate
              class = "loader"
              :size = "50"
              ></v-progress-circular>
        </div>
        <div class = "planContainer">
            <div class = "selectPlanContainer">
                <p v-show = "stepIncrement === 2 && isLoading === false" class = "selectPlan">Select your plan</p>
            </div>
        </div>
        <div class = "mainContainer" v-show = "stepIncrement === 2 && isLoading === false">
            <planSelection
                @selectPlan="selectPlan"
            />
        </div>
        <div class = "mainContainer" v-show = "stepIncrement === 3 && isLoading === false">
            <PlanCard
                v-if = "stepIncrement === 3 && isLoading === false"
                :portfolio="portfolio"/>
            <p class = "escrowBalanceText mb-30">Enter amount</p>
            <ValidationProvider
                style="width: 100%"
                name="Amount"
                :rules="amountRules"
                v-slot="{ errors, classes }"
            >
                <div class = "superContainer mb-30">
                    <div class = "inputContainer" :class="classes">
                        &#x20B9;
                        <input
                            id = "amountId"
                            type="number"
                            class="center"
                            maxLength="7"
                            onKeyPress="if(this.value.length==7) return false;"
                            v-model="amount"
                            placeholder="0"
                            autofocus
                            ref="check"
                            v-on:keyup="adjustInput"
                            @input="validateAmount"
                        />
                    </div>
                    <small class="errorText">{{ errors[0] }}</small>
                    <small class="errorText" v-show = "investmentCondition">The sum of the already invested and entered amount must be greater than 5,000.</small>
                </div>
                <div class = "inputContainer">
                    <button class="buttonSubmit btn_new btn-secondary-new" @click="checkEscrow()" :disabled="!(errors.length === 0) || !amount || investmentCondition">Invest</button>
                </div>
            </ValidationProvider>
        </div>
        <div class = "mainContainer" v-show = "stepIncrement === 4 && isLoading === false">
            <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_42mtixws.json"  background="transparent"  speed="1"  style="width: 120px; height: 120px;"  loop autoplay></lottie-player>
            <p class = "successfulText">Successfully invested!</p>
            <hr class = "mb-5 width">
            <div class = "columnContainer mb-20">
                <div class = "rowContainer">
                    <span class = "planTypeText mr-10">{{portfolio.planType}} {{portfolio.riskProfile}}</span>
                    <span class = "amountText ml-10">&#x20B9;{{amount | localeAmount}}</span>
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
import planSelection from '@/components/common/selectPlan.vue'
import LenderService from '@/services/lenderService'
import PlanCard from '@/components/common/planCard/planCardNew.vue'

export default {
    name: 'escrowInvestDialog',
    components: {
        planSelection,
        PlanCard
    },
    props: {
        step: Number,
        escrowBalance: Number,
        incomeAmount: Number,
        isEscrow: Boolean,
        isMonthly: Boolean
    },
    watch: {
        step: {
            handler (newValue, oldValue) {
                this.stepIncrement = newValue
            },
            deep: true,
            immediate: true
        }
    },
    data () {
        return {
            isLoading: false,
            portfolio: {},
            stepIncrement: this.step,
            amount: this.escrowBalance - this.incomeAmount,
            amountRules: 'amountValidation:5000000,1|required',
            investmentCondition: false,
            isEscrowData: this.isEscrow,
            isMonthlyData: this.isMonthly
        }
    },
    mounted () {
        if (this.isEscrowData === true && this.isMonthlyData === false) {
            this.amount = this.escrowBalance - this.incomeAmount
        } else if (this.isEscrowData === false && this.isMonthlyData === true) {
            this.amount = this.incomeAmount
        }
        const style = document.getElementById('amountId')
        this.adjustInitializeInput(style)
        this.amountRules = `amountValidation:${this.amount},1|required`
    },
    methods: {
        focusButton () {
            this.$nextTick(() => {
                const check = this.$refs.check
                check.focus()
            })
        },
        success () {
            this.$emit('success')
        },
        handleDialogClose () {
            this.$emit('handleDialogClose')
        },
        choosePlan () {
            this.success()
        },
        adjustInitializeInput (event) {
            event.style.width = this.amount.toString().length + 'ch'
        },
        adjustInput (event) {
            if (event.target.value.length === 0) {
                event.target.style.width = '15px'
            } else {
                event.target.style.width = event.target.value.length + 'ch'
            }
        },
        validateAmount () {
            if ((this.portfolio.investmentAmount + (this.amount * 100)) < 500000) {
                this.investmentCondition = true
            } else {
                this.investmentCondition = false
            }
            const amount = this.amount
            const sep = String(12.21).match(/\D/)[0]
            const b = amount.toString().split(sep)
            if (b[1]) {
                if (b[1].length > 2) {
                    this.amount = b[0] + '.' + b[1].slice(0, 2)
                }
            }
        },
        checkEscrow () {
            this.portfolio.investmentAmount = this.amount * 100
            if (this.isEscrowData === true && this.isMonthlyData === false) {
                this.payPortfolio(this.portfolio)
            } else if (this.isEscrowData === false && this.isMonthlyData === true) {
                this.payPortfolioIncome(this.portfolio)
            }
        },
        selectPlan (planName) {
            this.selectedPortfolio = planName
            this.checkIfPlanExists()
        },
        checkIfPlanExists () {
            this.isLoading = true
            const query = 'portfolio=' + this.selectedPortfolio
            LenderService.checkIfPortfolioExists(query).then((res) => {
                this.isLoading = false
                if (res.status === 200) {
                    if (res.data?.riskProfile) {
                        this.portfolio.portfolioId = res.data._id
                        this.portfolio.riskProfile = res.data.riskProfile
                        this.portfolio.planType = res.data.planType
                        if (res.data?.investmentAmount) {
                            this.portfolio.investmentAmount = res.data.investmentAmount
                        } else {
                            this.portfolio.investmentAmount = 0
                        }
                        this.success()
                        this.focusButton()
                        this.validateAmount()
                    } else {
                        this.createPortFolio()
                    }
                }
            })
        },
        createPortFolio () {
            this.isLoading = true
            const payload = {
                portfolio: this.selectedPortfolio
            }
            LenderService.createNewPortfolio(payload).then((res) => {
                this.isLoading = false
                if (res.status === 200) {
                    this.portfolio.investmentAmount = 0
                    this.portfolio.portfolioId = res.data._id
                    this.portfolio.riskProfile = res.data.riskProfile
                    this.portfolio.planType = res.data.planType
                    this.success()
                    this.focusButton()
                    this.validateAmount()
                }
            })
        },
        async payPortfolio (payload) {
            this.isLoading = true
            await LenderService.payInvestmentPortfolio(payload).then((res) => {
                this.isLoading = false
                if (res.status === 200) {
                    this.success()
                    setTimeout(() => {
                        this.handleDialogClose()
                        window.location.reload()
                    }, 3000)
                } else if (res.status === 402) {
                    this.handleDialogClose()
                    this.$emit('insufficientFunds')
                }
            })
        },
        async payPortfolioIncome (payload) {
            this.isLoading = true
            await LenderService.payInvestmentIncomePortfolio(payload).then((res) => {
                this.isLoading = false
                if (res.status === 200) {
                    this.success()
                    setTimeout(() => {
                        this.handleDialogClose()
                        window.location.reload()
                    }, 3000)
                } else if (res.status === 402) {
                    this.handleDialogClose()
                    this.$emit('insufficientFunds')
                }
            })
        }
    }
}
</script>
  <style lang="scss" scoped>
  @import "~@/sass/components/registration-flow.scss";
  @import "@/components/dashboard/dashboard.scss";

  hr {
    border: 0;
    clear:both;
    display:block;
    width: 96%;
    background-color:#e0e0e0;
    height: 1px;
  }
  .amountText {
      font-size: 17px;
      color: #002fa7;
      font-weight: 500;
  }
  .planTypeText {
      text-transform: capitalize;
      font-size: 17px;
      color: #232323;
      font-weight: 500;
      width: 100%
  }
  .backButtonContainer {
      margin-top: 7px;
      margin-left: 16px
  }
  ::v-deep .v-dialog::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
  }
  ::v-deep .v-dialog {
      border-radius: 16px
  }
  .icons {
      font-size: 15px;
      color: #007aff
  }
  .tryAgainText {
      font-weight: 500;
      font-size: 13px;
      color: #8C8C8C;
  }
  .successfulText {
    font-size: 19px;
    padding-bottom: 15px;
    font-weight: 500;
    color: #002fa7;
    text-align: center;
  }
  .failureText {
    font-size: 21px;
    padding-top: 25px;
    font-weight: 700;
    color: #F21E1E;
    text-align: center;
  }
  .amountConfirmation {
      color: #232323 !important;
      font-weight: 600
  }
  .confirmationText {
      text-align: center;
      color: #4f4f4f;
      font-size: 17px
  }
  .superContainer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
  }

  .width {
    max-width: 400px;
  }
  .columnContainer {
      max-width: 400px;
      min-width: 300px;
      display: flex;
      flex-direction: column;
  }

  .rowContainer {
      width: 100%;
      padding-top: 16px;
      display: flex;
      flex-direction: row;
  }
  .errorText {
      color: #e45f5f !important;
      font-size: 12px;
  }

  ::placeholder {
      color: #e0e0e0
  }
  .inputContainer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
  }
  .selectPlanContainer {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
  }
  .planContainer {
      padding-top: 2px;
      display: flex;
      flex-direction: row;
  }
  .selectPlan {
      font-weight: 600;
      font-size: 17px;
      margin-left: 30px;
      margin-bottom: 0px;
  }
  ::v-deep .v-dialog {
      width: 450px !important;
  }
  .v-card__title {
    line-height: 24px;
    word-break: normal;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dialog-custom {
    height: 120px !important;
    background: #ffffff;
    border: 1px solid #b9b9bb !important;
    box-sizing: border-box !important;
    border-radius: 21px !important;

  }

  .v-text-field .v-label {
    font-weight: bold !important;
  }
  .dialog-header-custom {
    width: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }

  .mainContainer {
      width: 100%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }

  input[type=number] {
    border: none;
    background-color: none;
    outline: 0;
    font-size: 25px;
  }

  input[type=number]:focus {
    border: none;
    background-color: none;
    outline: 0;
  }

  .escrowBalanceText {
      font-weight: 700;
      font-size: 21px;
      color: #232323;
  }

  .escrowBalanceStatic {
      line-height: 1.5;
      width: 90%;
      text-align: center;
      margin-bottom: 25px;
      font-weight: 400;
      font-size: 13px;
      color: #007aff;
  }

  .escrowBalance {
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 30px;
      color: #232323;
  }

  .buttonSubmit {
      margin-bottom: 30px;
      height: 40px !important;
      font-size: 14px !important;
  }

  .buttonConfirm {
      height: 40px !important;
      font-size: 14px !important;
      width: 120px !important;
  }

  .loadingContainer {
      height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .loader {
        padding-top: 200px;
        height: 42px !important;
        width: 42px !important;
        color: #007AFF;
    }

  .v-dialog > .v-card > .v-card__title {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
  }

  @media (max-width: 480px) {

      ::v-deep .v-dialog {
          width: 100% !important;
          margin: 15px !important;
      }
      ::v-deep .v-card__title {
          padding: 0px
      }
      .v-dialog > .v-card > .v-card__title {
          padding-left: 0px !important;
          padding-right: 0px !important;
          padding-top: 0px !important;
          padding-bottom: 0px !important;
      }
      .escrowBalanceText {
          font-size: 21px;
          margin-bottom: 2px;
      }

      .escrowBalanceStatic {
          font-size: 13px;
          text-align: center !important;
      }

      .escrowBalance {
          font-size: 24px;
      }

      .mainContainer {
          padding: 13px;
      }
      ::v-deep .v-dialog:not(.v-dialog--fullscreen) {
          max-height: 100% !important;
      }
      .selectPlan {
          margin-left: 20px !important
      }
      .selectPlanContainer {
          align-items: baseline !important;
      }
  }
  </style>
